import React from 'react';
import jsQR from 'jsqr';
import ByteUtils from './ByteUtils';

class QrScanner extends React.Component {
  constructor(props) {
    super(props);
    this.videoRef = React.createRef();
    this.canvasRef = React.createRef();

    this.tick = this.tick.bind(this);
  }

  tick() {
    const canvasElement = this.canvasRef.current;
    const canvas = canvasElement.getContext('2d');
    const video = this.videoRef.current;
    if (video.readyState === video.HAVE_ENOUGH_DATA) {
      canvasElement.height = video.videoHeight;
      canvasElement.width = video.videoWidth;
      canvas.drawImage(video, 0, 0, canvasElement.width, canvasElement.height);
      const imageData = canvas.getImageData(
        0,
        0,
        canvasElement.width,
        canvasElement.height
      );
      const code = jsQR(imageData.data, imageData.width, imageData.height, {
        inversionAttempts: 'dontInvert',
      });
      if (code)
        this.props.handleScan(
          ByteUtils.byteArrayToArrayBuffer(code.binaryData)
        );
    }
    requestAnimationFrame(this.tick);
  }

  componentDidMount() {
    navigator.mediaDevices
      .getUserMedia({ video: { facingMode: 'user' } })
      .then(handleSuccess.bind(this));

    function handleSuccess(stream) {
      this.videoRef.current.srcObject = stream;
      // this.videoRef.current.video.setAttribute("playsinline", true); // required to tell iOS safari we don't want fullscreen
      this.videoRef.current.play();
      requestAnimationFrame(this.tick);
    }
  }

  componentWillUnmount() {
    // this.html5Qrcode.stop().catch(error => {
    //     console.error('Failed to stop html5Qrcode. ', error);
    // });
  }

  render() {
    return (
      <div>
        <video
          id='camera-video'
          ref={this.videoRef}
          playsInline
          autoPlay
          hidden
        />
        <canvas
          id='camera-canvas'
          ref={this.canvasRef}
          hidden={this.props.hidden}
        />
      </div>
    );
  }
}

export default QrScanner;
